import styles from "./style.module.css"
import Typography from "../Typography/Typography"
import { useNavigate } from "react-router-dom";
import { getRelativeTime } from "../../utils/relativeTime";
import { productImg } from "../../assets/images";

interface Order {
    id?: string;
    name?: string;
    category?: string
    address?: string;
    item?: number;
    date?: string;
    price?: number;
    status?: React.ReactNode;
    route?: string;
    onClick?: () => void
}

export const ProductListItem: React.FC<Order> = ({
    id,
    name,
    category,
    address,
    item,
    date,
    price,
    status,
    route,
    onClick,
}) => {

    const navigate = useNavigate()

    const routing = (id: string) => {
        if (route) {
            navigate(`${route}/${id}`)
        } else {
            return ""
        }
    }

    return (
        <div className={styles.container}
            onClick={() => {
                if (id) { routing(id) }
                if (onClick) {
                    return onClick()
                }
            }}
        >

            <div className={styles.leftHandSide}>

                <div className={styles.imgContainer}>

                    <img className={styles.img} src={productImg} alt="" />

                </div>

                <div>

                    <div>
                        <Typography
                            variant="heading6"
                            className={styles.idDate}
                        >
                            {name}
                        </Typography>
                    </div>

                    <div>
                        <Typography
                            variant="heading6"
                            className={styles.address}
                        >
                            {category}
                        </Typography>
                    </div>

                    <div>
                        <Typography>
                            ${price}
                        </Typography>
                    </div>

                </div>

            </div>

            <div className={styles.rightHandSide}>

                <div
                    onClick={(e) => { e.stopPropagation() }}
                >
                    {status}
                </div>

                {/* <div className={styles.price}>
                    <Typography>
                        Price: ${price}
                    </Typography>
                </div> */}

            </div>

        </div>
    )
}